const defaultOptions = require('./defaultOptions');
const getModule = require('./getModule');
const fetchFile = require('./fetchFile');

module.exports = {
  defaultOptions,
  getModule,
  fetchFile,
};
